import script from "./GameFlex.vue?vue&type=script&lang=ts"
export * from "./GameFlex.vue?vue&type=script&lang=ts"

import "./GameFlex.vue?vue&type=style&index=0&id=0e50a87c&lang=scss"

export default script